import { CampaignGoalType, CampaignGoalName } from '@marketing-milk/interfaces'

export interface CampaignGoalOptimizationI {
  icon: string
  name: string
  type: CampaignGoalType
  description: string
  lastUsed: boolean
}

/**
 * The reporting buckets, for the screens that group or label campaigns by where their spend
 * rolls up. The descriptions say what the bucket reports on, not what a campaign is delivered
 * for — delivery is the optimization catalog's, and the two must not describe the same thing.
 */
export const campaignGoalOptimizations: CampaignGoalOptimizationI[] = [
  {
    icon: 'store',
    name: CampaignGoalName.InStoreSales,
    type: CampaignGoalType.InStoreSales,
    description: 'Awareness campaigns — reach and impressions.',
    lastUsed: false,
  },
  {
    icon: 'cart-arrow-down',
    name: CampaignGoalName.ECommerceSales,
    type: CampaignGoalType.ECommerceSales,
    description: 'Sales campaigns — purchases and other high-value site events.',
    lastUsed: false,
  },
  {
    icon: 'user-plus',
    name: CampaignGoalName.LeadGeneration,
    type: CampaignGoalType.LeadGeneration,
    description: 'Lead campaigns — instant forms and lead events on your site.',
    lastUsed: true,
  },
  {
    icon: 'desktop',
    name: CampaignGoalName.WebsiteSessions,
    type: CampaignGoalType.WebsiteSessions,
    description: 'Traffic and engagement campaigns — site visits and site conversions.',
    lastUsed: false,
  },
]
